/* eslint-disable no-underscore-dangle */
import { PHOTO_CONTAINER } from "../constants"

export default class ContainerElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof ContainerElement
   */
  static fromHtmlElement(htmlElement) {
    return new ContainerElement(htmlElement.querySelector(PHOTO_CONTAINER))
  }

  /**
   * Creates an instance of ContainerElement.
   * @param {HTMLElement} element
   * @memberof ContainerElement
   */
  constructor(element) {
    this.element = element

    this._onClickCallabckList = []
    this.element.addEventListener("click", (event) => {
      event.preventDefault()
      this._onClickCallabckList.forEach((cb) => cb())
    })
  }

  onClick(callback) {
    this._onClickCallabckList.push(callback)
  }
}
